import AddRoundedIcon from "@mui/icons-material/AddRounded";
import FolderOpenRoundedIcon from "@mui/icons-material/FolderOpenRounded";
import { Box, Button, Stack, Tooltip, Typography } from "@mui/material";
import { Link } from "react-router";
import { pageRoutes } from "../../../../../routes.ts";

interface Props {
  onAddTemplate: () => void;
  readonly?: boolean;
}
export default function OrganizationTemplatesPageHeader({ onAddTemplate, readonly }: Props) {
  return (
    <Stack direction="row" sx={{ alignItems: "center", flex: 1, justifyContent: "space-between", py: 2, px: 3 }}>
      <Typography variant="subtitle1">Report Templates</Typography>
      <Box id="controls" sx={{ display: "flex", gap: 1 }}>
        <Button
          variant="outlined"
          color="secondary"
          startIcon={<FolderOpenRoundedIcon />}
          component={Link}
          to={pageRoutes.reportLevels}
        >
          Group Settings
        </Button>
        <Tooltip
          title="To manage report templates, it is essential to have at least one company with Reporting Admin permission"
          placement="bottom"
          disableHoverListener={!readonly}
          arrow
          disableInteractive
        >
          <span>
            <Button variant="contained" startIcon={<AddRoundedIcon />} onClick={onAddTemplate} disabled={readonly}>
              New Template
            </Button>
          </span>
        </Tooltip>
      </Box>
    </Stack>
  );
}
